import React from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { JuliaMessageMetadata } from '../../types';

interface JuliaSourcesProps {
  metadata?: JuliaMessageMetadata | null;
}

const JuliaSources: React.FC<JuliaSourcesProps> = ({ metadata }) => {
  if (!metadata) return null;

  const { sources = [], actions = [] } = metadata;
  if (sources.length === 0 && actions.length === 0) return null;

  return (
    <div style={{ marginTop: '0.75rem', paddingTop: '0.75rem', borderTop: '1px solid var(--color-border-light)' }}>
      {sources.length > 0 && (
        <div style={{ marginBottom: actions.length ? '0.5rem' : 0 }}>
          <p style={{ margin: '0 0 0.35rem', fontSize: '0.65rem', fontWeight: 700, color: 'var(--color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Sources consultées
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
            {sources.map((src) => (
              <Link
                key={`${src.tool}-${src.path}`}
                to={src.path}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.25rem',
                  fontSize: '0.65rem',
                  padding: '0.2rem 0.5rem',
                  borderRadius: 'var(--radius-full)',
                  background: 'var(--color-brand-light)',
                  color: 'var(--color-brand)',
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                {src.label}
                {src.detail && <span style={{ fontWeight: 400, opacity: 0.85 }}>({src.detail})</span>}
                <FiExternalLink size={10} />
              </Link>
            ))}
          </div>
        </div>
      )}
      {actions.length > 0 && (
        <div>
          <p style={{ margin: '0 0 0.35rem', fontSize: '0.65rem', fontWeight: 700, color: 'var(--color-success)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Données mises à jour
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
            {actions.map((action) => (
              <Link
                key={`${action.tool}-${action.label}`}
                to={action.path || '#'}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.25rem',
                  fontSize: '0.65rem',
                  padding: '0.2rem 0.5rem',
                  borderRadius: 'var(--radius-full)',
                  background: 'var(--color-success-light)',
                  color: 'var(--color-success)',
                  textDecoration: 'none',
                  fontWeight: 600,
                }}
              >
                {action.label}
                <FiExternalLink size={10} />
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default JuliaSources;
